export * from '../constants-generated';

/** Storage key under which the shopping context data gets stored. */
export const CONTEXT_KEY = 'shoppingContext';

/** Local storage data will be cleaned on next reload when older than this timeout (currently 5 minutes in ms). */
export const DATA_CACHE_TIMEOUT = 300000;

/** In some situations, we mark the local cache to be cleaned after page reload with this flag. */
export const SCHEDULED_CLEANUP_KEY = `basket-provider cache cleanup`;

/** User cookie helps identifying the current shopping session. */
export const USER_COOKIE_NAME = 'ShoppingKey';

/** GUID of the UseIndexedDb feature toggle. */
export const USE_INDEXED_DB_FT_GUID = '121C4156-31A6-4259-BCEC-954302CA7659';

/**
 * Experimental delay before the shopping-context-loaded event gets triggered.
 * This is here to fix problems in automated UI tests, if possible.
 */
export const POST_INIT_EVENT_DELAY = 200;
export const LOG_COLOR = '090';
//# sourceMappingURL=index.js.map